import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiPieChart, FiUsers, FiDollarSign, FiFileText, FiMenu } from "react-icons/fi";

const TABS = [
  { id: "dashboard", label: "Home", icon: FiPieChart, path: "/", match: ["/"] },
  { id: "users", label: "Users", icon: FiUsers, path: "/all-user-list", match: ["/all-user-list", "/active-user-list", "/inactive-user-list"] },
  { id: "payments", label: "Payments", icon: FiDollarSign, path: "/deposit-pending", match: ["/deposit-pending", "/deposit-approve", "/deposit-rejected", "/withdrawal-pending", "/withdrawal-approve", "/withdrawal-rejected"] },
  { id: "reports", label: "Reports", icon: FiFileText, path: "/deposit-report", match: ["/deposit-report", "/withdraw-report", "/bonus-report", "/penalty-report"] },
];

/**
 * Fixed bottom navigation for phone widths (hidden above 767.98px via CSS).
 * The full menu isn't duplicated here — "More" simply opens the same
 * Sidebar the header hamburger already controls; on this breakpoint it
 * renders as a bottom sheet instead of a left drawer (see admin-theme-v2).
 */
const MobileTabBar = ({ onOpenMore, isMoreOpen }) => {
  const location = useLocation();
  const isActive = (tab) =>
    tab.match.some((path) => (path === "/" ? location.pathname === "/" : location.pathname.startsWith(path)));

  return (
    <nav className="mobile-tab-bar" aria-label="Primary">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        return (
          <Link
            key={tab.id}
            to={tab.path}
            className={`mobile-tab-bar__item ${isActive(tab) ? "is-active" : ""}`}
          >
            <Icon />
            <span>{tab.label}</span>
          </Link>
        );
      })}

      <button
        type="button"
        className={`mobile-tab-bar__item mobile-tab-bar__item--more ${isMoreOpen ? "is-active" : ""}`}
        onClick={onOpenMore}
        aria-label="More"
      >
        <FiMenu />
        <span>More</span>
      </button>
    </nav>
  );
};

export default MobileTabBar;
